// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import { usePublicLang } from "../config/i18n/public";

export default function Footer() {
  const { copy } = usePublicLang();
  const c = copy.footer;
  const year = new Date().getFullYear();

  return (
    <footer className="w-full border-t border-black/5 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="py-2 flex flex-col items-center gap-2 sm:flex-row sm:justify-between">
          {/* Left: copyright */}
          <p className="order-2 sm:order-1 text-[10px] sm:text-xs text-gray-500">
            © {year} SteffiCare
          </p>

          {/* Right: nav links */}
          <nav
            className="order-1 sm:order-2 w-full sm:w-auto"
            aria-label="Footer Navigation"
          >
            <ul className="flex flex-wrap justify-center sm:justify-end gap-x-4 gap-y-1 text-[10px] sm:text-xs text-gray-500">
              <li>
                <Link
                  to="/nutzungsbedingungen"
                  className="hover:text-gray-700 hover:underline focus:outline-none focus-visible:ring-1 focus-visible:ring-blue-400 rounded"
                >
                  {c.terms}
                </Link>
              </li>
              <li>
                <Link
                  to="/impressum"
                  className="hover:text-gray-700 hover:underline focus:outline-none focus-visible:ring-1 focus-visible:ring-blue-400 rounded"
                >
                  {c.imprint}
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutzhinweis"
                  className="hover:text-gray-700 hover:underline focus:outline-none focus-visible:ring-1 focus-visible:ring-blue-400 rounded"
                >
                  {c.privacy}
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
